const meta = {
  'prometheus-recommendations': 'Prometheus metric naming recommendations',
  'operator-collector': 'Prometheus Operator differences',
};

export default meta;
